module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.index.title')) + "\n        (" + _vm._s(_vm.clients.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions client-options"
  }, [_c('el-button-group', {
    staticClass: "client-view-type"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  })], 1), _vm._v(" "), _c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "static.clients.index.search",
      "value": _vm.search,
      "clearable": true
    },
    on: {
      "keydown": _vm.onChangeSearch
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('v-select', {
    staticClass: "sort",
    attrs: {
      "name": "sort",
      "options": _vm.sortTypes,
      "value": _vm.sort
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "client-import small",
    attrs: {
      "type": _vm.primary,
      "icon": "el-icon-download",
      "round": ""
    },
    on: {
      "click": _vm.showImportDownloadModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.downloadImport')) + "\n        ")])], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
    staticClass: "bulkActions",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6,
      "xl": 4
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " clients selected")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "md": 3,
      "lg": 3,
      "xl": 2
    }
  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('clientActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 13,
      "lg": 15,
      "xl": 18
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('isSubClient')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clientActions.isSubClient')))]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('isProducer')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clientActions.isProducer')))]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('activateClient')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clientActions.activateClient')))]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--danger danger small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('deactivateClient')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clientActions.deactivateClient')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.clients.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.client.noDataMsg')) + "\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'clients.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.client.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.clients.items), function(p, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "wide": true
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editClient(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editClientNewTab(p)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "full-w flex wrap client-title-container margin-b-10"
    }, [(p.picture) ? _c('img', {
      staticClass: "client-img margin-b-10",
      attrs: {
        "src": p.picture.url,
        "alt": p.companyName || ((p.firstName) + " " + (p.lastName))
      }
    }) : _c('div', {
      staticClass: "client-avatar-initials margin-b-10",
      style: ({
        backgroundColor: _vm.getAvatarColor(p)
      }),
      attrs: {
        "title": p.companyName || ((p.firstName) + " " + (p.lastName))
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getInitials(p)) + "\n          ")]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(p.companyName || ((p.firstName) + " " + (p.lastName))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.table.organizationNumber')) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.organizationNumber || '–'))])]), _vm._v(" "), (_vm.hasEHFModule) ? _c('div', {
      staticClass: "margin-b-10 client-ehf-card-block"
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.ehfListLabel')) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent client-ehf-card-value"
    }, [(p.ehfBilling3_0) ? _c('i', {
      staticClass: "fa fa-check-circle client-ehf-icon client-ehf-icon--yes",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-times-circle client-ehf-icon client-ehf-icon--no",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "client-ehf-card-text"
    }, [_vm._v(_vm._s(p.ehfBilling3_0 ? _vm.$t('static.clients.info.ehfListVerified') : _vm.$t('static.clients.info.ehfListNotVerified')))])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (p.phoneNumber || p.mobileNumber) ? [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.phone')) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.phoneNumber))]), _vm._v("\n          " + _vm._s((p.phoneNumber && p.mobileNumber) ? ' / ' : '') + "\n          "), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.mobileNumber))]), _c('br')] : _vm._e(), _vm._v(" "), _c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.email')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.email ||
      '-'))]), _vm._v(" "), _c('div', {
      staticClass: "client-metrics"
    }, [_c('div', {
      staticClass: "client-metric-row"
    }, [_c('span', {
      staticClass: "client-metric-label"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.totalOrders')))]), _vm._v(" "), _c('span', {
      staticClass: "client-metric-value"
    }, [_vm._v(_vm._s(p.ordersCount || 0))])]), _vm._v(" "), _c('div', {
      staticClass: "client-metric-row"
    }, [_c('span', {
      staticClass: "client-metric-label"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.totalRevenue')))]), _vm._v(" "), _c('span', {
      staticClass: "client-metric-value"
    }, [_vm._v(_vm._s(p.totalValueInvoiced.toFixed(2)) + " NOK")])]), _vm._v(" "), _c('div', {
      staticClass: "client-metric-row"
    }, [_c('span', {
      staticClass: "client-metric-label"
    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.pendingPayments')))]), _vm._v(" "), _c('span', {
      staticClass: "client-metric-value"
    }, [_vm._v(_vm._s(p.totalValueInvoicedDue.toFixed(2)) + " NOK")])])])], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.clientsListView
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "custNo",
      "label": _vm.$t('static.clients.table.custNo'),
      "sortable": "",
      "width": "88"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.clients.table.name'),
      "sortable": "",
      "min-width": "280",
      "class-name": "client-table-col-name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editClient(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3832337083)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "organizationNumber",
      "label": _vm.$t('static.clients.table.organizationNumber'),
      "sortable": "",
      "min-width": "120"
    }
  }), _vm._v(" "), (_vm.hasEHFModule) ? _c('el-table-column', {
    attrs: {
      "prop": "ehfSort",
      "label": _vm.$t('static.clients.info.ehfListLabel'),
      "sortable": "",
      "width": "220",
      "align": "left",
      "class-name": "client-table-col-ehf"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "client-ehf-table-cell"
        }, [(scope.row.ehfBilling3_0) ? _c('i', {
          staticClass: "fa fa-check-circle client-ehf-icon client-ehf-icon--yes",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _c('i', {
          staticClass: "fa fa-times-circle client-ehf-icon client-ehf-icon--no",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "client-ehf-table-text"
        }, [_vm._v(_vm._s(scope.row.ehfBilling3_0 ? _vm.$t('static.clients.info.ehfListVerified') : _vm.$t('static.clients.info.ehfListNotVerified')))])])]
      }
    }], null, false, 3449862900)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "phone",
      "label": _vm.$t('static.clients.table.phone'),
      "min-width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "email",
      "label": _vm.$t('static.clients.table.email'),
      "sortable": "",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "ordersCount",
      "label": _vm.$t('static.clients.table.ordersCount'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "createdAt",
      "label": _vm.$t('static.clients.table.createdAt'),
      "sortable": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.clients.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e4ab80e","hasScoped":true}!./src/app/pages/withNavigation/clients/index/index.html
// module id = 3030
// module chunks = 1